import React, { useEffect, useState } from "react";
import { Link, Navigate, useSearchParams } from "react-router";
import Pagination from "../../../common/Pagination";
import { getVendorCallbacks } from "../../../redux/services/Ai Services/Ai.Services";
import {
  activeLeadType,
  callbackListRows,
  isHiddenVendorTestLead,
  isSplitLeadVendor,
  leadTypeLabel,
  listPageMeta,
  presentCallback,
} from "../../../Utils/role";

function CallbackList() {
  const [searchParams] = useSearchParams();
  const leadType = activeLeadType(searchParams.get("lead_type")) || "work";
  const typeLabel = leadTypeLabel(leadType);
  const [rows, setRows] = useState([]);
  const [initialLoading, setInitialLoading] = useState(true);
  const [tableLoading, setTableLoading] = useState(false);
  const [loadError, setLoadError] = useState("");
  const [page, setPage] = useState(1);
  const [limit] = useState(100);
  const [totalRows, setTotalRows] = useState(0);
  const [totalPages, setTotalPages] = useState(1);

  const fetchCallbacks = async (pageNo = 1, isInitialLoad = false) => {
    try {
      if (isInitialLoad) setInitialLoading(true);
      else setTableLoading(true);
      setLoadError("");

      let response;
      try {
        response = await getVendorCallbacks({
          lead_type: leadType,
          page: pageNo,
          per_page: limit,
        });
      } catch (error) {
        const status = error?.response?.status;
        if (pageNo === 1 && (status === 400 || status === 422)) {
          response = await getVendorCallbacks({ lead_type: leadType });
        } else {
          throw error;
        }
      }

      const list = callbackListRows(response).filter(
        (item) => !isHiddenVendorTestLead(item)
      );
      const pageMeta = listPageMeta(response, list.length, limit);
      const visible =
        list.length > limit
          ? list.slice((pageNo - 1) * limit, pageNo * limit)
          : list;

      setRows(visible.map(presentCallback));
      setPage(list.length > limit ? pageNo : pageMeta.page);
      setTotalPages(pageMeta.pages);
      setTotalRows(pageMeta.total);
    } catch (error) {
      console.log(error);
      setRows([]);
      setTotalRows(0);
      setTotalPages(1);
      setLoadError("Callbacks could not be loaded.");
    } finally {
      setInitialLoading(false);
      setTableLoading(false);
    }
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages && !tableLoading) {
      setPage(newPage);
      fetchCallbacks(newPage, false);
    }
  };

  useEffect(() => {
    fetchCallbacks(1, true);
  }, [leadType]);

  if (!isSplitLeadVendor()) {
    return <Navigate to="/" replace />;
  }

  if (initialLoading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary"></div>
      </div>
    );
  }

  return (
    <div>
      <div className="d-flex align-items-center justify-content-between page-header-breadcrumb">
        <div className="title_member">
          <h4>{typeLabel} Callbacks</h4>
          <nav className="page-breadcrumb">
            <Link to="/">Home</Link>
            <span className="mx-2">/</span>
            <span>{typeLabel} Callbacks</span>
          </nav>
        </div>
      </div>
      <div className="main_page">
        <div className="row g-3 mb-3">
          <div className="col-12">
            <div className="st-wrapper-card p-3 text-start">
              <div className="text-muted">People who agreed to be contacted</div>
              <h4 className="mb-0">{totalRows.toLocaleString("en-IN")}</h4>
            </div>
          </div>
        </div>
        {totalPages > 1 && (
          <div className="d-flex justify-content-end mb-3">
            <Pagination
              page={page}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          </div>
        )}
        <div className="st-wrapper-card text-center">
          <div className="st-table-responsive">
            <table className="table st-custom-table align-middle mb-0">
              <thead>
                <tr>
                  <th>Sr.No</th>
                  <th>Name</th>
                  <th>Number</th>
                  <th>Date</th>
                  <th>Time</th>
                  <th>Details</th>
                </tr>
              </thead>
              <tbody>
                {tableLoading ? (
                  <tr>
                    <td colSpan={6} className="text-center">
                      Loading...
                    </td>
                  </tr>
                ) : rows.length > 0 ? (
                  rows.map((item, index) => (
                    <tr key={`${item.number}-${index}`}>
                      <td>{(page - 1) * limit + index + 1}</td>
                      <td>{item.name}</td>
                      <td>{item.number}</td>
                      <td>{item.date}</td>
                      <td>{item.time}</td>
                      <td>{item.details}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={6} className="text-center">
                      {loadError || "No callbacks found"}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            {totalPages > 1 && (
              <div className="d-flex justify-content-end mt-3">
                <Pagination
                  page={page}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CallbackList;
